module.exports = "<ng4-loading-spinner [timeout]=\"60000\"> </ng4-loading-spinner><app-layout><router-outlet></router-outlet></app-layout>\r\n"